import { Text } from '@comicrelief/component-library';
import {
  SocialsWrapper,
  FacebookIcon,
  XIcon,
  XIconWrapper
} from './PaymentStyles.style';
import { JOURNEY_TYPES } from '@/constants/constants';

interface SocialLinksProps {
  socialShareCTA: string;
  currencySymbol: string;
  cartId: string | undefined;
  paymentAmount: number;
  journeyType: string | undefined;
  prepopulatedSocialShareMessage: string | undefined
}

export default function SocialLinks({
  socialShareCTA,
  currencySymbol,
  cartId,
  paymentAmount,
  journeyType,
  prepopulatedSocialShareMessage
}: SocialLinksProps) {
  const openShareWindow = (
    event: React.MouseEvent<HTMLElement>,
    id: string
  ) => {
    event.preventDefault();

    const socialLinkBackDomain = `${document.location.origin}/?cartId=${cartId}`;
    const socialShareMessage = prepopulatedSocialShareMessage ?? 'I donated to Comic Relief! You can support Comic Relief too by donating here:%0a';

    const isPayin = journeyType === JOURNEY_TYPES.PAYIN;
    const thisAmount = `${currencySymbol}${paymentAmount}`;
    const shareMessage = isPayin ? `I fundraised ${thisAmount} for Comic Relief! You can support Comic Relief too by donating here:%0a` : `${socialShareMessage}`;

    // N.B.: Facebook has deprecated the 'quote' param we used to be able to pass a custom message via :(
    const targetUrl = id === 'facebook'
      ? `https://www.facebook.com/sharer/sharer.php?u=${socialLinkBackDomain}`
      : `https://x.com/share?text=${shareMessage}&url=`;

    window.open(targetUrl + socialLinkBackDomain, `${id}-popup`, 'height=350,width=600');
  };

  return (
    <SocialsWrapper>
      <Text
        tag="p"
        family="Montserrat"
        size="md"
        color="black"
        weight="bold"
      >
        {socialShareCTA}
      </Text>

      <a
        href="#facebook-share"
        aria-label="Share on Facebook. (Opens in a new window)."
        onClick={(e) => {
          openShareWindow(e, 'facebook');
        }}
      >
        <FacebookIcon
          src="/assets/images/social-media/facebook-icon.png"
          alt="Facebook icon"
        />
      </a>

      <a
        href="#x-share"
        aria-label="Share on X. (Opens in a new window)."
        onClick={(e) => {
          openShareWindow(e, 'x');
        }}
      >
        <XIconWrapper>
          <XIcon
            src="/assets/images/social-media/x-icon-white.png"
            alt="X icon"
          />
        </XIconWrapper>
      </a>
    </SocialsWrapper>

  );
}
